module.exports = __webpack_public_path__ + "static/media/optemization.6d1cbc42.jpg";